// 构建 FAQModal 初始化配置与问候语
// @param {Object} props - 初始化配置参数
// @param {string} props.userName - 用户名
// @param {string} props.page - 页面路径
// @param {string} props.lang - 语言
// @param {number} props.recodingMaxTime - 录音最大时长
// @param {number} props.recodingMinTime - 录音最短时长
// @param {boolean} props.activeDrag - 是否启用拖动功能
// @param {boolean} props.activeRecordAudio - 是否启用录音功能
// @param {string} props.theme - 主题样式 ('theme-1' | 'theme-2')
// @param {Object} props.themeCustomConfig - 主题自定义配置
// @param {Object} props.agentType - 机器人类型
// @param {Object} props.customizeContent - 自定义内容
// @param {Function} props.routeChange - 路由变化回调函数
export const buildInitConfig = (props = {}) => {
    const {
        userName = '',
        page = '',
        lang = 'en',
        recodingMaxTime = (120 * 1000),
        recodingMinTime = 1000,
        activeDrag = false, // 
        activeRecordAudio = false,
        theme = 'theme-1', // 默认主题1
        themeCustomConfig = {}, // 主题自定义配置
        agentType = {},
        customizeContent = {},
        routeChange
    } = props;

    const typeList = agentType?.type || [];
    const selectedInputType = agentType?.defaultType || typeList?.[0]?.type || '';

    // 构建问候语列表
    const greeting = customizeContent?.greeting;
    let greetingItems = [];
    const now = Date.now();

    if (greeting) {
        if (typeof greeting === 'string') {
            greetingItems = [{
                id: now,
                type: 'agent',
                content: greeting || `Hi ${userName}, I'm AI assistant.`
            }];
        } else if (Array.isArray(greeting)) {
            greetingItems = greeting.map((item, idx) => ({
                id: now + idx,
                type: 'agent',
                content: item
            }));
        }
    }

    if (!greetingItems.length) {
        greetingItems = [{
            id: now,
            type: 'agent',
            content: `Hi ${userName}, I'm AI assistant.`
        }];
    }

    const agentTitle = customizeContent?.agentTitle || 'AI Assistant';
    const agentLabel = customizeContent?.agentIcon || '<div class="label">AI</div>';
    const userLabel = customizeContent?.userIcon || '<div class="label">User</div>';
    const textPlaceholder = customizeContent?.textPlaceholder || 'Ask a question...';
    const inputLimit = customizeContent?.inputLimit || 500;

    const greetingPopup = !!(customizeContent?.greetingPopup && customizeContent?.greetingPopupContent);
    const greetingPopupContent = customizeContent?.greetingPopupContent || '';
    const routeChangeCb = typeof routeChange === 'function' ? routeChange : null;



    return {
        page,
        showAgentType: agentType?.showType || false,
        typeList,
        selectedInputType,
        apiPath: props?.apiPath,
        inputLimit,
        agentTitle,
        agentLabel,
        userLabel,
        textPlaceholder,
        greetingPopup,
        greetingPopupContent,
        routeChangeCb,
        greetingItems,
        lang,
        recodingMinTime,
        recodingMaxTime,
        activeDrag,
        activeRecordAudio,
        theme, // 添加主题配置
        themeCustomConfig, // 添加主题自定义配置

    };
};

